module.exports = __webpack_public_path__ + "static/monitor-lg-4d07d0f56e7346df698b148d0a1e8169.webp";